/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.formatter

import kotlinx.coroutines.flow.StateFlow
import kotlinx.datetime.LocalDate
import kotlinx.datetime.number
import studio.oddpods.cauce.core.model.UserData
import studio.oddpods.cauce.core.model.display.DateFormat

class DateFormatter(
    private val prefs: StateFlow<UserData>,
) {
    @Suppress("ReturnCount")
    fun format(isoDate: String?): String? {
        if (isoDate == null) return null
        val parsed = runCatching { LocalDate.parse(isoDate) }.getOrNull() ?: return isoDate
        val d = parsed.day.toString().padStart(2, '0')
        val m = parsed.month.number.toString().padStart(2, '0')
        val y = parsed.year.toString()
        return when (prefs.value.displayPreferences.dateFormat) {
            DateFormat.DMY_SLASH -> "$d/$m/$y"
            DateFormat.DMY_DASH -> "$d-$m-$y"
            DateFormat.YMD_DASH -> "$y-$m-$d"
        }
    }
}
